import React, { Component } from "react";
import { useSelector } from "react-redux";

export default function FileImagePreview({file, message, i}) {

  const uuid = useSelector(state => state.uuid.uuid);

  let width = (file.width > 183) ? 183 : file.width;
  let height = (file.width > 183) ? ((183 * file.height) / file.width) : file.height;

  return (
    <div key={file.id} className={"kil-chat-widget-conversation-files-image" + ((i == 0 && !message.message) ? ' no-margin-top' : '')}>
      <div style={{height: height+"px", width: width+"px"}} className="image-wrapper">
        <a target="_blank" href={`${file.urlClient}?uuid=${uuid}`}>
          <img src={`${file.urlClient}?preview=1&uuid=${uuid}`} alt="" />
        </a>
      </div>
    </div> 
  )
}